import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { UNHMosaicoItem } from '@frontend/unhideschool/app/utils/i18n/locale/unh-my-courses/models/unh-my-courses.i18n.model';
import { environment } from '@frontend/unhideschool/env';

@Component({
  selector: 'unh-mosaico-item',
  templateUrl: './mosaico-item.component.html',
  styleUrls: ['./mosaico-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MosaicoItemComponent {
  _projectPost;
  @Input() projectpost;
  @Input() hidefooter = false;
  @Input() ispro = false;
  @Input() isowned = false;
  @Input() progress: any;
  @Input() progressVisible = false;
  @Input() projectLink = null;
  @Input() loading = false;
  @Input() hideRibbons = false;
  @Input() ismycoursespage = false;
  @Input() hasActivePromo: boolean;
  @Input() mycoursesPlaceholder = false;

  loadingPlaceholder = 'loading';
  loaded: boolean;

  @Input() mosaicoItemTranslation: UNHMosaicoItem;



  @Output() enteredInView = new EventEmitter();
  imgLazyLoaded = false;
  image2;


  args = {
    backgroundCover: environment.cdnUrl + '/home-banner.svg',
    backgroundThumbnail: environment.cdnUrl + '/home-banner.jpg',
    avatar: environment.cdnUrl + '/avatar.svg',
    name: 'Ricardo Combat',
    profession: 'Ui Designer',
    tags: [
      environment.cdnUrl + '/blender-icon.svg', 
      environment.cdnUrl + '/photoshop-icon.svg', 
      environment.cdnUrl + '/spark-icon.svg'
    ],
    description: [
      {
        icon: environment.cdnUrl + '/icon-level.svg',
        title: 'Nível',
        text: 'Básico ao Intermediário',
      },
      {
        icon: environment.cdnUrl + '/icon-level.svg',
        title: 'Nível',
        text: 'Básico ao Intermediário',
      },
      {
        icon: environment.cdnUrl + '/icon-level.svg',
        title: 'Nível',
        text: 'Básico ao Intermediário',
      },
      {
        icon: environment.cdnUrl + '/icon-clock.svg',
        title: 'Duração',
        text: '9h 29min',
      },
      {
        icon: environment.cdnUrl + '/icon-sound.svg',
        title: 'Audio',
        text: 'Português',
      },
      {
        icon: environment.cdnUrl + '/icon-legends.svg',
        title: 'Legenda',
        text: 'Português/Inglês/Espanhol',
      },
    ],
    cardTitle: 'Fundamentos de Texturização no Substance Painter',
  };

}

